import {Folder} from '../../../Assets.types';
import findFolderInTree from './findFolderInTree';

/**
 * Derive current folder object from assetTree and currentFolderId
 * @param assetTree - The tree structure
 * @param currentFolderId - ID of the current folder
 * @returns The current folder object if found, null otherwise
 */
export default function getCurrentFolder(
  assetTree: Folder | null,
  currentFolderId: number | null,
): Folder | null {
  if (!assetTree || currentFolderId === null) {
    return null;
  }

  return findFolderInTree(assetTree, currentFolderId);
}

